import React, { useState, useContext } from 'react'

const StateContext = React.createContext()

export const useStateValue = () => useContext(StateContext)

const StateProvider = props => {
  const [team, setTeam] = useState([])
  const [teamName, setTeamName] = useState('Unnamed Team')
  const [seenAlert, setSeenAlert] = useState(0)
  const [seenLoginAlert, setSeenLoginAlert] = useState(0)
  
  //Loads some default characters for you
  const [characters, setCharacters] = useState([
    {id: 1009368, name: 'Iron Man', img: 'http://i.annihil.us/u/prod/marvel/i/mg/9/c0/527bb7b37ff55/standard_xlarge.jpg'},
    {id: 1009220, name: 'Captain America', img: 'http://i.annihil.us/u/prod/marvel/i/mg/3/50/537ba56d31087/standard_xlarge.jpg'},
    {id: 1009351, name: 'Hulk', img: 'http://i.annihil.us/u/prod/marvel/i/mg/5/a0/538615ca33ab0/standard_xlarge.jpg'},
    {id: 1009189, name: 'Black Widow', img: 'http://i.annihil.us/u/prod/marvel/i/mg/f/30/50fecad1f395b/standard_xlarge.jpg'},
    {id: 1009187, name: 'Black Panther', img: 'http://i.annihil.us/u/prod/marvel/i/mg/6/60/5261a80a67e7d/standard_xlarge.jpg'},
    {id: 1010338, name: 'Captain Marvel', img: 'http://i.annihil.us/u/prod/marvel/i/mg/6/80/5269608c1be7a/standard_xlarge.jpg'},
    {id: 1009664, name: 'Thor', img: 'http://i.annihil.us/u/prod/marvel/i/mg/d/d0/5269657a74350/standard_xlarge.jpg'},
    {id: 1009610, name: 'Spider-Man', img: 'http://i.annihil.us/u/prod/marvel/i/mg/3/50/526548a343e4b/standard_xlarge.jpg'},
    {id: 1009297, name: 'Falcon', img: 'http://i.annihil.us/u/prod/marvel/i/mg/f/b0/5111505fb7009/standard_xlarge.jpg'},
    {id: 1010740, name: 'Winter Soldier', img: 'http://i.annihil.us/u/prod/marvel/i/mg/d/03/5265478293c1e/standard_xlarge.jpg'},
    {id: 1009338, name: 'Hawkeye', img: 'http://i.annihil.us/u/prod/marvel/i/mg/e/90/50fecaf4f101b/standard_xlarge.jpg'},
    {id: 1009282, name: 'Doctor Strange', img: 'http://i.annihil.us/u/prod/marvel/i/mg/5/f0/5261a85a501fe/standard_xlarge.jpg'}
  ])

  const addCharacters = data => {
    setCharacters(data.data.results.map(character => (
      {
        id: character.id,
        name: character.name,
        img: character.thumbnail.path + '/standard_xlarge.' + character.thumbnail.extension
      }
    )))
  }

  const addToTeam = character => {
    setTeam([...team, character])
  }

  const removeFromTeam = ids => {
    setTeam(team.filter(c => !ids.includes(c.id)))
  }

  const newTeamName = name => setTeamName(name)

  //So you only see Alert once in Villain mode
  const changeAlert = newAlert => setSeenAlert(newAlert)

  //So you only see LoginAlert when you first arrive
  const changeLoginAlert = newAlert => setSeenLoginAlert(newAlert)

  const value = {
    team,
    teamName,
    seenAlert,
    seenLoginAlert,
    characters,
    addCharacters,
    addToTeam,
    removeFromTeam,
    newTeamName,
    changeAlert,
    changeLoginAlert
  }

	return (
		<StateContext.Provider value={value}>
			{props.children}
		</StateContext.Provider>
	)
}

export default StateProvider
